<template>
  <div class="testAnnouncement" :class="focused ? 'bg-glass disabled' : 'normal'" v-if="isBetaEnv">
    <!-- <div>
      <span>{{ $t('memo_list.test_announcement.content') }}</span>
      <a href="https://help.flomoapp.com/community/wechat-group.html" target="_blank">{{
        $t('memo_list.test_announcement.btn.feed')
      }}</a
      >。
      <a href="https://flomoapp.com/login/">{{ $t('memo_list.test_announcement.btn.back') }}</a>
    </div> -->
    <div>当前为内测版，新功能会先发布至此，数据与正式版互通。如遇问题，请在内测群反馈。</div>
  </div>
</template>
<script>
import { isBetaEnv } from '@/utils/utils'
export default {
  name: 'TestAnnouncement',
  data() {
    return {
      isBetaEnv: isBetaEnv(),
    }
  },
  computed: {
    focused() {
      return this.$store.state.focused
    },
  },
}
</script>
<style scoped>
.testAnnouncement {
  background: var(--BgTestAnnouncement);
  border-bottom: 1px solid var(--BgTestAnnouncement);
}
.testAnnouncement div {
  border-radius: 6px;
  padding: 8px;
  text-align: center;
  font-size: 12px;
  line-height: 17px;
  color: #9d9d9d;
}

.testAnnouncement div a {
  color: #9d9d9d;
}
</style>
